import React from 'react';
import { connect } from 'react-redux';
import Header from '../../components/Header';
// import Button from '../../components/Button';
import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomeIndex from './home';
import EtChart from '../../components/et_chart';

const App = () => (
  <div className="App">
    {/* <Header /> */}
    <BrowserRouter>
    <Routes>
    <Route path="/"element={ <HomeIndex />}/>
    <Route path='/chart' element={<EtChart />}/>
    <Route path='/annual' element={<EtChart />}/>

    </Routes>
    </BrowserRouter>

  </div>
);

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(App);
